import React, { useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import './PdfContent.css';

pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.js';

export const PdfContent = ({ fileBlob }: { fileBlob: Blob | null }) => {
    const [numPages, setNumPages] = useState<number | null>(null);
    const [error, setError] = useState<string | null>(null);
    const [scale, setScale] = useState(1.0);

    const onLoadSuccess = ({ numPages }: { numPages: number }) => {
        setNumPages(numPages);
    };

    const onLoadError = () => {
        setError('Error loading PDF');
    };

    const zoomIn = () => setScale((s) => Math.min(s + 0.2, 3));
    const zoomOut = () => setScale((s) => Math.max(s - 0.2, 0.5));

    if (error) {
        return <div>Error: {error}</div>;
    }

    return (
        <div
            style={{
                position: 'relative',
                width: '100%',
                height: '100%',
                border: '1px solid #ccc',
                boxSizing: 'border-box',
                overflow: 'hidden',
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            <div
                style={{
                    position: 'absolute',
                    top: 10,
                    right: 10,
                    display: 'flex',
                    alignItems: 'center',
                    backgroundColor: 'rgba(0,0,0,0.05)',
                    border: '1px solid #ccc',
                    borderRadius: 6,
                    overflow: 'hidden',
                    userSelect: 'none',
                    width: 60,
                    height: 30,
                    zIndex: 1000,
                }}
            >
                <button
                    onClick={zoomIn}
                    style={{
                        flex: 1,
                        border: 'none',
                        background: 'transparent',
                        fontSize: 20,
                        cursor: 'pointer',
                        color: '#333',
                        outline: 'none',
                        padding: 0,
                        lineHeight: 1,
                    }}
                    aria-label="Zoom In"
                    type="button"
                >
                    +
                </button>
                <div
                    style={{
                        width: 1,
                        height: '80%',
                        backgroundColor: '#999',
                        alignSelf: 'center',
                    }}
                />
                <button
                    onClick={zoomOut}
                    style={{
                        flex: 1,
                        border: 'none',
                        background: 'transparent',
                        fontSize: 20,
                        cursor: 'pointer',
                        color: '#333',
                        outline: 'none',
                        padding: 0,
                        lineHeight: 1,
                    }}
                    aria-label="Zoom Out"
                    type="button"
                >
                    −
                </button>
            </div>

            <div
                style={{
                    width: '100%',
                    height: '100%',
                    overflowY: 'auto',
                    overflowX: 'auto',
                    boxSizing: 'border-box',
                    padding: '20px 10px 10px 10px',
                }}
            >
                <div
                    style={{
                        minWidth: 'min-content',
                        margin: '0 auto',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}
                >
                    <Document
                        file={fileBlob}
                        onLoadSuccess={onLoadSuccess}
                        onLoadError={onLoadError}
                        loading={<div>Loading PDF document...</div>}
                    >
                        {numPages &&
                            Array.from(new Array(numPages), (_el, index) => (
                                <div
                                    key={`page_wrapper_${index + 1}`}
                                    style={{
                                        display: 'block',
                                        marginBottom: 10,
                                    }}
                                >
                                    <Page
                                        key={`page_${index + 1}`}
                                        pageNumber={index + 1}
                                        scale={scale}
                                        loading={
                                            <div>
                                                Loading page {index + 1}...
                                            </div>
                                        }
                                    />
                                </div>
                            ))}
                    </Document>
                </div>
            </div>
        </div>
    );
};
